import { useCallback, useEffect, useRef } from 'react';
import { toast } from 'react-toastify';
import { useTranslation } from 'react-i18next';

export function useAdsgram({ blockId, onReward, onError, fetchBalance, showToast = true }) {
	const AdControllerRef = useRef(undefined);
	const { t } = useTranslation();

	useEffect(() => {
		if (window.Adsgram?.init) {
			AdControllerRef.current = window.Adsgram.init({ blockId });
		}
	}, [blockId]);

	return useCallback(async () => {
		if (AdControllerRef.current) {
			AdControllerRef.current
				.show()
				.then(async () => {
					// Пауза 1 секунда
					await new Promise(res => setTimeout(res, 1000));
					if (fetchBalance) {
						await fetchBalance();
					}
					if (showToast) {
						toast.success(
							t('common.rewardReceived'),
							{
								position: 'top-center',
								autoClose: 2000,
							}
						);
					}
					onReward && onReward();
				})
				.catch((result) => {
					onError?.(result);
				});
		} else {
			onError?.({
				error: true,
				done: false,
				state: 'load',
				description: 'Adsgram script not loaded',
			});
		}
	}, [onError, onReward, fetchBalance, t, showToast]);
} 